export default "__VITE_ASSET__fb8b1246__"